export default __webpack_public_path__ + "static/media/logo-top-trim-icon-reposition.438fe891.png";